import React from "react";
import { ReactComponent as ArrowLeftIcon } from "../../../../assets/images/icons/arrowLeft.svg";
import { useTranslation } from "react-i18next";
import "./SettingsHeader.scss";
type Props = {
  title: string;
  onBack: () => void;
};
const SettingsHeader: React.FC<Props> = ({ title, onBack }) => {
  const { t } = useTranslation();
  return (
    <div className="settingsHeader">
      <div className="">
        <div className="back" onClick={() => onBack()}>
          <ArrowLeftIcon />
          <span>{t("Back")}</span>
        </div>
        <div className="title">{title}</div>
      </div>
      <div></div>
    </div>
  );
};

export default SettingsHeader;
